import React, { Component } from "react";

export default class TablaHeader extends Component {
	render() {
		return (
			<thead>
				{this.props.cat === "comparsa" ? (
					<tr className="tablaHeader">
						<th>#</th>
						<th>Agr</th>
						<th>Tipo</th>
						<th>Pre.</th>
						<th>Pas.</th>
						<th>Cup.</th>
						<th>Estr.</th>
						<th>Pop.</th>
						<th>Semi.</th>
						<th>Arr.</th>
						<th>Tot.</th>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "chirigota" ? (
					<tr className="tablaHeader">
						<th>#</th>
						<th>Agr</th>
						<th>Tipo</th>
						<th>Pre.</th>
						<th>Pas.</th>
						<th>Cup.</th>
						<th>Estr.</th>
						<th>Pop.</th>
						<th>Semi.</th>
						<th>Arr.</th>
						<th>Tot.</th>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "coro" ? (
					<tr className="tablaHeader">
						<th>#</th>
						<th>Agr</th>
						<th>Tipo</th>
						<th>Pre.</th>
						<th>Tan.</th>
						<th>Cup.</th>
						<th>Estr.</th>
						<th>Pop.</th>
						<th>Semi.</th>
						<th>Arr.</th>
						<th>Tot.</th>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "cuarteto" ? (
					<tr className="tablaHeader">
						<th>#</th>
						<th>Agr</th>
						<th>Tipo</th>
						<th>Parodia</th>
						<th>Cuplés</th>
						<th>Estribillo</th>
						<th>T.Libre</th>
						<th>Semi.</th>
						<th>Arr.</th>
						<th>Tot.</th>
					</tr>
				) : (
					""
				)}
			</thead>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TablaHeader.js